module.exports = __webpack_public_path__ + "assets/img/wj-icon.fb874289.png";